<template>
  <v-container>
    <app-confirm ref="confirm"></app-confirm>
    <app-alert ref="alert"></app-alert>
    <app-information-banner
      v-if="bannerText"
      :BannerText="bannerText"
    ></app-information-banner>
    <v-card class="mx-auto">
      <v-card-title class="primary white--text text-uppercase controlled-font">
        <span class="text-break"
          ><v-icon color="white" left> mdi-clipboard-edit-outline </v-icon>
          {{ questionDetails.questionText }}</span
        >
      </v-card-title>
      <v-card-text>
        <v-layout row wrap mx-auto class="mt-2">
          <v-flex sm6>
            <app-radio-buttons
              :options="answers"
              :selection="selectedAnswer"
              @change="onSelectedAnswerChanged"
              ref="answers"
              :buttonSpacing="10"
            >
            </app-radio-buttons>
          </v-flex>
          <v-flex sm6 align-self-center class="pa-5 mx-auto">
            <div class="image mx-auto text-center">
              <expandable-image
                class="mx-auto rounded"
                :src="image"
                :close-on-background-click="true"
              >
              </expandable-image>
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>

    <v-card class="mx-auto mt-4">
      <v-card-title class="primary white--text controlled-font">
        <v-row>
          <v-col class="col-10">
            <v-icon controlled-font center color="white" v-if="showVideo"
              >$apASL</v-icon
            >
            <v-icon v-else color="white">mdi-account-voice</v-icon>

            {{ !showVideo ? siteText.ui.audioTitle : siteText.ui.aslTitle }}
          </v-col>
          <v-col class="col-2 text-right mx-auto" v-show="hasVideo">
            <!-- <img :src="aslWhite" class="icon" /> -->
            <v-btn
              depressed
              outlined
              id="toggle"
              class="primary btn-toggle"
              @click="toggleVideoAudio"
            >
              <v-icon large center color="white" v-if="!showVideo"
                >$apASL</v-icon
              >
              <v-icon v-else center color="white">mdi-account-voice</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-layout row class="ma-2">
          <v-flex sm6 class="text-center align-bottom">
            <app-video-player
              v-if="showVideo"
              :playList="video"
              :hideVolume="true"
              width="500"
            >
            </app-video-player>
            <app-audio-player
              v-else
              class="mt-2 ml-2 mb-0"
              :playList="audioPlayList"
              :defaultVolume="defaultAudioVolume"
              @volumeChanged="onVolumeChanged"
              width="500"
            ></app-audio-player>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
/*const SAS_KEY =
  "?sv=2020-02-10&ss=bfqt&srt=sco&sp=rlupx&se=2023-11-02T04:00:00Z&st=2021-11-02T04:00:00Z&spr=https&sig=v09yKtUAFa8qh%2FWj91gY4TwWtzH37AzByUXtuIwBA0g%3D";
*/
import Vue from "vue";
import VueExpandableImage from "vue-expandable-image";
Vue.use(VueExpandableImage);

import { mapGetters } from "vuex";
import { mapActions } from "vuex";

import appAudioPlayer from "../components/audioPlayer/AudioPlayer.vue";
import appVideoPlayer from "../components/videoPlayer/VideoPlayer.vue";
import appRadioButtons from "../components/ui/RadioButtons.vue";
import appConfirm from "./ui/Confirm.vue";
import appInformationBanner from "./ui/InformationBanner.vue";
import appAlert from "./ui/Alert.vue";

export default {
  components: {
    appConfirm,
    appAlert,
    appInformationBanner,
    appRadioButtons,
    appAudioPlayer,
    appVideoPlayer,
  },
  props: {
    questionDetails: {
      require: true,
    },
    totalQuestions: Number,
    displayAlert: Boolean,
    displaySkipQuestion: Boolean,
    messageText: String,
  },
  data() {
    return {
      selectedAnswer: "",
      showVideo: false,
      sampleVideo: require("../assets/Asl Sample Video-8.mp4"),
    };
  },
  computed: {
    ...mapGetters([
      "baseApiUrl",
      "siteText",
      "defaultAudioVolume",
      "userSession",
      "mediaUrl",
    ]),
    bannerText() {
      return this.messageText;
    },
    answers() {
      let answers = [];
      if (this.questionDetails && this.questionDetails.answers) {
        answers = this.questionDetails.answers.map((answer) => {
          return {
            key: answer.answerChoice,
            text: `${answer.answerChoice}. ${answer.answerText}`,
          };
        });
      }
      return answers;
    },
    image() {
      return this.questionDetails.imageBlobPath
        ? `${this.mediaUrl}${this.questionDetails.imageBlobPath}?${this.userSession.authToken.sasToken}`
        : "";
    },
    audio() {
      return this.questionDetails.audioPlayList
        ? `${this.baseApiUrl}Documents/AudioFile/${this.questionDetails.audioPlayList[0]}`
        : "";
    },
    video() {
      let playList = [];
      if (this.questionDetails.aslBlobPlayList) {
        playList = this.questionDetails.aslBlobPlayList.map((a) => {
          return `${this.mediaUrl}${a}?${this.userSession.authToken.sasToken}`;
        });
        console.log(playList);
      }
      return playList;
    },
    hasVideo() {
      return (
        this.questionDetails.aslBlobPlayList &&
        this.questionDetails.aslBlobPlayList.length > 0
      );
    },
    audioPlayList() {
      let playList = [];
      if (this.questionDetails.audioBlobPlayList) {
        playList = this.questionDetails.audioBlobPlayList.map((a) => {
          return `${this.mediaUrl}${a}?${this.userSession.authToken.sasToken}`;
        });
        console.log(playList);
      }
      return playList;
    },
    showSkipQuestion() {
      return this.displaySkipQuestion;
    },
  },
  methods: {
    ...mapActions(["updateAudioVolume"]),
    async onSelectedAnswerChanged(answer) {
      let answerSelected = true;
      if (this.displayAlert) {
        answerSelected = await this.$refs.confirm.open(
          this.siteText.ui.confirmation,
          this.siteText.ui.questionAnswerConfirmation,
          {
            ok: this.siteText.ui.yes,
            cancel: this.siteText.ui.no,
          }
        );
        if (!answerSelected) {
          this.clearAnswerSelection();
        }
      }

      if (answerSelected) {
        this.selectedAnswer = answer;
        this.$emit("onAnswerChanged", answer);
      }
    },
    clearAnswerSelection() {
      this.selectedAnswer = "";
      this.$refs.answers.clearSelection();
    },
    async onSkipQuestion() {},
    toggleVideoAudio() {
      this.showVideo = !this.showVideo;
      if (this.showVideo) {
        window.scroll({
          left: 0,
          top: 600,
          behavior: "smooth",
        });
      }
    },
    onVolumeChanged(value) {
      //Set Volume In Session//
      this.updateAudioVolume(value);
    },
  },
  watch: {
    questionDetails(newValue, oldValue) {
      if (newValue !== oldValue) {
        const selectedAnswer = newValue.answers.find((a) => a.isSelected);
        if (!selectedAnswer) {
          this.$refs.answers.clearSelection();
        } else {
          this.selectedAnswer = selectedAnswer.answerChoice;
        }

        if (!this.hasVideo) {
          this.showVideo = false;
        }
      }
    },
  },
};
</script>

<style scoped>
.v-card {
  /*max-width: 1300px;*/
  min-height: 150px;
}
/* .v-radio {
  max-width: 300px;
} */

.white--text /deep/ label {
  color: white;
}

.white--radio /deep/ input {
  color: white;
}

.v-btn {
  border: 1px solid white !important;
}

.image {
  max-height: 300px;
  max-width: 300px;
}

.icon {
  max-height: 48px;
  max-width: 48px;
}

.btn-toggle {
  max-width: 16px;
  max-height: 16px;
  margin: -10px;
}

.btn-toggle.v-btn--outlined {
  border: 1px white solid !important;
}

body .expandable-image.expanded {
  background: rgba(116, 116, 116, 0.8);
}

.container {
  padding-left: 5px !important;
  padding-right: 5px !important;
}
</style>
